{
	"addressGranularity": {
		"AR": "postal_code",
		"AU": "postal_code",
		"CA": "city_and_postal_code",
		"DE": "postal_code",
		"ES": "postal_code",
		"FR": "postal_code",
		"GB": "city_and_postal_code",
		"GF": "postal_code",
		"GP": "postal_code",
		"ID": "postal_code",
		"IN": "postal_code",
		"IT": "postal_code",
		"JP": "postal_code",
		"MQ": "postal_code",
		"MX": "postal_code",
		"NC": "postal_code",
		"NL": "postal_code",
		"PF": "postal_code",
		"PM": "postal_code",
		"PT": "postal_code",
		"RE": "postal_code",
		"UK": "city_and_postal_code",
		"US": "city_and_postal_code",
		"WF": "postal_code",
		"YT": "postal_code"
	}
}
